"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Top cart/serach actions
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.topCartSearch = {
    initialize: function () {
        'use strict';
        var $body, $cart, $search, $searchInput;
        $body = $('body');
        $cart = $('#top_cart_button');
        $search = $('#top_search');
        $searchInput = $search.find('input');
        $searchInput.on('focusin', function () {
            $body.addClass('top-cart-search-toggled');
        }).on('focusout', function () {
            $body.removeClass('top-cart-search-toggled');
        });
    }
};
exports.default = {};
